import React, {useEffect, useState} from "react";
import {useProductListContext} from "../productListProvider/ProductListProvider";
import {ProductListOrder, ProductListOrderBy} from "@connox/typescript-library";
import {useTranslation} from "react-i18next";
import Select, {SelectOptionType} from "../../molecules/Select";
import {useMediaQuery} from "react-responsive";
import RadioButton from "../../lib/form/RadioButton/RadioButton";
import {getShopId} from "../../lib/getShopId";

export type SortOption = SelectOptionType & {
  orderBy: ProductListOrderBy;
  order: ProductListOrder;
};

const ProductSortInput: React.FC = () => {
  const {state, dispatch} = useProductListContext();
  const {t} = useTranslation();
  const isMobile = useMediaQuery({query: "(max-width: 940px)"});

  const sortOptions: SortOption[] = [
    {
      value: 1,
      text: t("product.mostPopular"),
      orderBy: "rank",
      order: "asc",
    },
    {
      value: 2,
      text: t("product.highestRebate"),
      orderBy: "percentageDiscount",
      order: "desc",
    },
    {
      value: 3,
      text: t("product.highestPrice"),
      orderBy: "price",
      order: "desc",
    },
    {
      value: 4,
      text: t("product.lowestPrice"),
      orderBy: "price",
      order: "asc",
    },
    {
      value: 5,
      text: t("product.latest"),
      orderBy: "newest",
      order: "desc",
    },
  ];

  // Show only in DE. Also refer to the initializing `useMemo()` in `ProductListProvider.tsx`
  if (getShopId() === 100001) {
    sortOptions.push({
      value: 6,
      text: t("product.bestMatches"),
      orderBy: "innofind",
      order: "asc",
    });
  }

  const [selectedOptionValueNumber, setSelectedOptionValueNumber] = useState<number>(
    Number(sortOptions.find((so) => so.orderBy === state.orderBy && so.order === state.order)?.value) ?? 1,
  );

  useEffect(() => {
    const item = sortOptions.find((option) => {
      return option.orderBy === state.orderBy && option.order === state.order;
    });
    setSelectedOptionValueNumber(item ? (item.value as number) : 1);
  }, [state.order, state.orderBy]);

  const onChange = (value: string | number) => {
    const item = sortOptions.find((option) => option.value === Number(value));
    setSelectedOptionValueNumber(item ? (item.value as number) : 1);
    dispatch({
      type: "SET_SORT",
      payload: {orderBy: item?.orderBy ?? undefined, order: item?.order ?? undefined, doUrlParamUpdate: true},
    });
  };

  return (
    <>
      {!isMobile && (
        <>
          <Select
            value={selectedOptionValueNumber}
            styles={{
              wrapper: "filter-sort__dd",
            }}
            onChange={onChange}
            options={sortOptions}
          />
        </>
      )}
      {isMobile && (
        <div className="filter-sort__list mb-8">
          {sortOptions.map((option) => {
            return (
              <div key={option.value} className="py-3">
                <RadioButton
                  value={option.value}
                  checked={selectedOptionValueNumber === option.value}
                  name={"sort"}
                  color={"#41a561"}
                  onChange={(evt) => {
                    onChange(evt.target.value);
                  }}
                >
                  {option.text}
                </RadioButton>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ProductSortInput;
